import Index from './index.vue'
import List from './components/List.vue'

export default [
  {
    path: 'advance-payment',
    name: 'advance-payment',
    component: Index,
    title: 'advance-payment',
    redirect: { name: 'advance-payment-list' },
    children: [      
      {
        path: 'list',
        name: 'advance-payment-list',
        component: List,
      },      
    ],
  },
]
